import IframeResizerCellPlugin from "./cell_plugins/iframe_resizer_cell_plugin";
import TinyMceCellPlugin from "./cell_plugins/tinymce_cell_plugin";
import ConditionalContainerPlugin from "./cell_plugins/containers/conditional_container_plugin";
import VideoRoomCellPlugin from "./cell_plugins/video_room_cell_plugin";
import PhotoBoothCellPlugin from "./cell_plugins/photo_booth_cell_plugin";
import RegistrationPageCellPlugin from "./cell_plugins/registration_page_cell_plugin";
import RowContainerPlugin from "./cell_plugins/containers/row_container_plugin";
import HtmlContentPopupContainerPlugin from "./cell_plugins/containers/html_content_popup_container_plugin";

const cellPlugins = [
  // slate(),
  TinyMceCellPlugin(),
  ConditionalContainerPlugin(),
  VideoRoomCellPlugin,
  PhotoBoothCellPlugin,
  IframeResizerCellPlugin,
  RegistrationPageCellPlugin,
  HtmlContentPopupContainerPlugin(),
]

export default cellPlugins